define('arrayUtils',['require','utils'],function(require) {
    'use strict';
    var utils = require('utils');
    return {
        /**
         * Sum the values of the given column. If column is not passed, it sums the items.
         * @param {Array} array 
         * @param {String} column (optional)
         * @returns {decimal} 
         */
        sum: function(array, column) {
            var sum = 0;
            array.forEach(function(item) {
                sum += column == null ? item : item[column];
            });
            return sum;
        },

        /**
         * Returns the distinct values for the given columns.
         * If no columns are passed in, it uses the whole object
         * If more than one columns are passed in, it uses the whole object
         * If one column is  passed, it passes back just the values in there
         * @param {Array} array 
         * @param {string} columnsCSV (optional)
         * @returns {Array} 
         */
        distinct: function(array, columnsCSV) {
            var columns = columnsCSV == null ? [] : columnsCSV.split(',');
            var isComplex = columns.length > 1;
            var isSingle = columns.length === 1;
            var distinctResult = [];
            var result;
            var exists = false;
            array.forEach(function(item) {
                if (isComplex) {
                    result = {};
                    columns.forEach(function(column) {
                        result[column] = item[column];
                    });
                } else if (isSingle) {
                    result = item[columnsCSV];
                } else {
                    result = item;
                }
                exists = !distinctResult.some(function(dr) {
                    return utils.equals(dr, result);
                });
                if (exists) {
                    distinctResult.push(result);
                }
            });
            return distinctResult;
        },

        /**
         * Sort the values in the given array using the given column
         * @param {Array} array 
         * @param {string} column 
         * @param {bool} desc 
         * @returns {array} 
         */
        sort: function(array, column, desc) {
            array.sort(function(aItem, bItem) {
                var a = aItem[column];
                var b = bItem[column];
                if (utils.isString(a)) {
                    a = a.toLowerCase();
                    b = b.toLowerCase();
                }
                return a === b ? 0 : ((a < b && !desc) || (a > b && desc)) ? -1 : 1;
            });
            return array;
        }
    };
});
